<div class="_points-container flex flex-middle bg-col-w b-a b-col-42">
    <i [class]="type === 'coins' ? 'icon-coins' : 'icon-rosette'"
       class="m-r-1 inline-flex"
       style="font-size: 24px;"></i>
    @if (text) {
    <span class="p3"> {{text | translate : points }} </span>
    } @else {
    <span class="p1">{{points}}</span>
    }
</div>
